;(function(){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  data: function data() {
    return {
      minutes: "",
      seconds: "",
      timerRunning: false
    };
  },
  mounted: function mounted() {
    this.startTimer();
  },


  computed: {
    startTimer: function startTimer() {
      var _this = this;

      var expiryTime = new Date().getTime() + 120000;
      setInterval(function () {
        var currentTime = new Date().getTime();
        var timeLeft = expiryTime - currentTime;
        _this.minutes = Math.floor(timeLeft % (1000 * 60 * 60) / (1000 * 60));
        _this.seconds = Math.floor(timeLeft % (1000 * 60) / 1000);
        if (timeLeft < 0) {
          clearInterval();
          _this.timerRunning = false;
          _this.$emit("update:timer", false);
        }
      }, 1000);
    }
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_vm._v("OTP expires in "+_vm._s(_vm.minutes)+":"+_vm._s(_vm.seconds))])}
__vue__options__.staticRenderFns = []
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-4910170b", __vue__options__)
  } else {
    hotAPI.reload("data-v-4910170b", __vue__options__)
  }
})()}